<template>
  <div class="view pa24">

    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="140px" class="ruleForm">
        <el-form-item label="所属父级" prop="parentName">
          <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull" :disabled="isShow"
            v-model="parentName" style="width: 300px;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.id"
              style="display: none;" />
            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
              highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode" :lazy="true"
              :load="load" collapse-tags />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="组配所需数量" prop="fitNum">
          <el-input-number v-model="ruleForm.fitNum" :readonly="isShow" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="规格" prop="specName">
          <el-input v-model="ruleForm.specName" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="件号" prop="partNumber">
          <el-input v-model="ruleForm.partNumber" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="modelNo">
          <el-input v-model="ruleForm.modelNo" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="存货编码" prop="inventCode">
          <el-input v-model="ruleForm.inventCode" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="库存预警数" prop="stockWarningNum">
          <el-input-number v-model="ruleForm.stockWarningNum" :disabled="isShow"></el-input-number>
        </el-form-item>
        <el-form-item label="是否需要备件" prop="needSpare">
          <el-radio-group v-model="ruleForm.needSpare" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提醒SCM系统" prop="isRemindScm" v-if="ruleForm.needSpare">
          <el-radio-group v-model="ruleForm.isRemindScm" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提醒APS系统" prop="isRemindAps" v-if="ruleForm.needSpare">
          <el-radio-group v-model="ruleForm.isRemindAps" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="检测批号" v-if="ruleForm.isNeedOutsourcing" prop="detectionBatchNumber">
          <el-input v-model="ruleForm.detectionBatchNo" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="合格证书" v-if="ruleForm.isNeedOutsourcing" prop="">
          <comm-upload-file :files="ruleForm.certQualityList" @clk="certUpload" :limit="1"
            :readonly="isShow"></comm-upload-file>
        </el-form-item>
        <el-form-item label="合格证有效期" v-if="ruleForm.isNeedOutsourcing">
          <el-date-picker v-model="ruleForm.certValidity" :disabled="isShow" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" v-model="ruleForm.sort" :readonly="isShow"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isShow">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddCustomer">确 定</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isShow">
        <el-button @click="closeDialog">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { addPageClass } from '@/api/customPageClass.js'
  import CommUploadFile from "@/components/CommUploadFile.vue";
  import { selectStoreClassList } from '@/api/storeClass.js'

  export default {
    name: "addPageClass",
    components: {
      CommUploadFile
    },
    props: [],

    data() {
      let token = localStorage.getItem("token")
      return {
        fileList: [],
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        upParams: {
          token: token
        },
        provinces: [],
        classType: null,
        dialogVisible: false,
        title: '添加产品类别',
        parentId: '',
        parentName: '',
        treeProps: {
          children: 'children',
          label: 'name',
          isLeaf: 'isLeaf'
        },
        expandOnClickNode: false,
        ruleForm: {
          id: '',
          name: '',
          sort: 999,
          parentId: null,
          busName: '',
          goodsCode: '',
          specCode: '',
          specName: '',
          classType: 0,
          stockWarningNum: '',
          partNumber: '',
          isRemindScm: false,
          isRemindAps: false,
          productQualification: '',
          isNeedOutsourcing: false,
          detectionBatchNo: '',
          certQuality: '',
          certValidity: '',
          productQualificationList: [],
          certQualityList: [],
          needSpare: false,
          inventCode: '',
          modelNo: '',
          isProduct: false,
          fitNum: 1
        },
        rules: {
          name: [
            { required: true, message: '请输入类别名称', trigger: 'blur' },
          ],
          busName: [
            { required: true, message: '请输入商家名称', trigger: 'blur' },
          ],
          goodsCode: [
            { required: true, message: '请输入货品编码', trigger: 'blur' },
          ],
          // specCode: [
          //   {required: true, message: '请输入规格码', trigger: 'blur'},
          // ],
          // specName: [
          //   {required: true, message: '请输入规格名称', trigger: 'blur'},
          // ],
          isRemindAps: [
            { required: true, message: '请选择是否提醒APS系统', trigger: 'blur' },
          ],
          isRemindScm: [
            { required: true, message: '请选择是否提醒SCM系统', trigger: 'blur' },
          ],
          isNeedOutsourcing: [
            { required: true, message: '请选择是否需要委外检测', trigger: 'blur' },
          ],
          detectionBatchNumber: [
            { required: true, message: '请输入检测批号', trigger: 'blur' },
          ],
          certValidity: [
            { required: true, message: '请输入合格证有效期', trigger: 'blur' },
          ],
          needSpare: [
            { required: true, message: '请选择是否需要备件', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            {
              type: 'number',
              message: '手机号格式不正确',
              trigger: 'blur',
              transform(value) {
                var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
                if (!phonereg.test(value)) {
                  return false
                } else {
                  return Number(value)
                }
              }
            }
          ]

        },
        type: 'add',
        id: '',
        classList: [{ value: 0, label: 'fadsfs' }],
        isShow: false
      };
    },
    onShow() {

    },
    mounted() {
    },
    methods: {
      load(node, resolve) {
        let params = {
          noPage: true,
          type: this.classType,
          name: this.name,
          classType: 0,
          status: this.storeStatus,
          parentId: node.data.id
        }
        selectStoreClassList(params).then(res => {
          res.data.list.forEach(item => {
            item.isLeaf = !item.hasChildren
          })
          return resolve(res.data.list)
        })
      },
      finishUpload(files) {
        this.ruleForm.productQualificationList = files
      },
      certUpload(files) {
        this.ruleForm.certQualityList = files
      },
      handleCheckChange(node, list) {
        this.ruleForm.parentId = node.id;
        //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
        if (list.checkedKeys.length == 2) {
          //单选实现
          this.$refs.selectTree.setCheckedKeys([node.id]);
        }
      },
      getAllClass() {
        let params = {
          pageNum: 1,
          pageSize: 100000,
          type: 0,
          classType: 0
        }
        this.classList = []
        selectStoreClassList(params).then(res => {
          res.data.list.forEach(item => {
            item.isLeaf = !item.hasChildren
          })
          this.classList = res.data.list
        })
      },
      async openDialog(type, data, classType) {
        this.getAllClass()
        this.dialogVisible = true
        this.classType = classType
        if (type === 'add') {
          this.title = '添加BOM结构'
          this.type = 'add'
          this.$refs.dealerRuleForm.resetFields();
          this.id = ''
          this.ruleForm.name = ''
          this.isShow = false
        } else if (type === 'edit') {
          this.ruleForm = JSON.parse(JSON.stringify(data))
          this.ruleForm.parentId = data.parentId
          this.parentName = '顶级'
          if (data.parentName) {
            this.parentName = data.parentName
          }
          this.title = '编辑BOM结构'
          this.type = "edit"
          this.id = data.id
          this.isShow = false
        } else if (type === 'show') {
          this.ruleForm = data
          this.ruleForm.parentId = data.parentId
          this.parentName = '顶级'
          if (data.parentName) {
            this.parentName = data.parentName
          }
          this.title = '查看产品类别'
          this.isShow = true
        }
      },
      handleNodeClick(node) {
        this.ruleForm.parentId = node.id
        this.parentName = node.name
        this.$refs.selectTree.blur();
      },
      setValueNull() {
        this.ruleForm.parentId = '';
        this.parentName = ''
      },
      optionData(array, result = []) {
        array.forEach(item => {
          result.push({
            label: item.name,
            value: item.id
          })
          if (item.children && item.children.length !== 0) {
            this.optionData(item.children, result)
          }
        })
        return JSON.parse(JSON.stringify(result))
      },
      closeDialog() {
        this.dialogVisible = false
        this.resetForm()

      },
      resetForm() {
        this.$refs.dealerRuleForm.resetFields();
      },
      confirmAddCustomer() {
        this.$refs.dealerRuleForm.validate((valid) => {
          if (valid) {
            if (this.type === 'edit') {
              this.ruleForm.id = this.id
              addPageClass(this.ruleForm).then(res => {
                if (res.code === 200) {
                  this.$message({
                    type: "success",
                    message: "操作成功",
                  });
                  this.closeDialog()
                }
              })
            } else {
              this.ruleForm.id = ''
              addPageClass(this.ruleForm).then(res => {
                if (res.code === 200) {
                  this.closeDialog()
                  this.$message({
                    type: "success",
                    message: "操作成功",
                  });
                  this.$emit('getList')
                }
              })
            }
          }
        })
      },
      // 回显
      getData(data) {
        this.ruleForm = data
        let obj = this.classList[0].children.filter(it => it.id === data.parentId);
        if (obj) {
          this.parentName = obj[0].name
        }
      },
    },


  };
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10 rpx;
  }
</style>